if (!customElements.get('rm-oct-demo')) {
  customElements.define('rm-oct-demo', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.video = this.querySelector('video');
      this.popup = this.querySelector('.rm-oct__demo-popup');
      if (!this.details || !this.video) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const step = this.closest('.rm-oct__step');
      this.querySelector('summary').addEventListener('click', () => {
        this.pinned = !this.details.open;
      }, options);
      step.addEventListener('pointerenter', () => {
        clearTimeout(this.closeTimer);
        if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        this.details.open = true;
      }, options);
      step.addEventListener('pointerleave', () => {
        this.closeTimer = setTimeout(() => {
          if (!this.pinned && !this.details.matches(':focus-within')) this.close();
        }, 180);
      }, options);
      this.details.addEventListener('toggle', () => {
        if (!this.details.open) {
          this.video.pause();
          if (this.video.readyState) this.video.currentTime = 0;
          return;
        }
        this.positionPopup();
        document.querySelectorAll('rm-oct-demo').forEach(other => {
          if (other !== this) other.close?.();
        });
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.video.muted = true;
          this.video.play().catch(() => {});
        }
      }, options);
      this.querySelector('.rm-oct__demo-close').addEventListener('click', () => {
        this.close();
        this.querySelector('summary').focus();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.details.open) {
          this.close();
          this.querySelector('summary').focus();
        }
      }, options);
      this.addEventListener('focusout', () => {
        if (!this.pinned && !step.matches(':hover')) this.close();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.close();
      }, options);
      window.addEventListener('resize', () => this.positionPopup(), options);
      window.addEventListener('scroll', () => this.positionPopup(), { ...options, passive: true });
      this.observer = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) this.close();
      });
      this.observer.observe(step);
    }
    positionPopup() {
      if (!this.details?.open) return;
      let shift = 0;
      if (matchMedia('(min-width: 750px)').matches) {
        const top = this.closest('.rm-oct__step').getBoundingClientRect().top - 8 - this.popup.offsetHeight;
        shift = Math.max(0, 12 - top);
      }
      this.popup.style.setProperty('--rm-oct-demo-shift', `${shift}px`);
    }
    close() {
      clearTimeout(this.closeTimer);
      this.pinned = false;
      if (this.details) this.details.open = false;
      this.video?.pause();
    }
    disconnectedCallback() {
      this.close();
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
